/**
 * 全局自定义指令
 */
import Vue from 'vue';
import { clickoutside } from './clickoutside';
import { preventReClick } from './preventReClick';
import { noSpecialChars } from './noSpecialChars';
import './tooltipMove.js';

Vue.directive(clickoutside.name, clickoutside.option);
Vue.directive(preventReClick.name, preventReClick.option);
Vue.directive(noSpecialChars.name, noSpecialChars.option);
